import React from "react";

import "./smart_insights_icon.scss";

const SmartInsightsIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" className="smart-insights-icon">
    <g id="Intelligent_Alarms" data-name="Intelligent Alarms" transform="translate(16 16)">
      <g id="Group_17306" data-name="Group 17306" transform="translate(-16 -16)">
        <rect id="Margin" className="cls-1" width="32" height="32" />
        <g id="Group_17305" data-name="Group 17305">
          <rect id="Rectangle_7021" data-name="Rectangle 7021" className="cls-2" width="14.846" height="12.619" transform="translate(8.577 9.826)" />
          <g id="Group_17301" data-name="Group 17301">
            <rect id="Rectangle_7022" data-name="Rectangle 7022" className="cls-3" width="2.017" height="3.476" transform="translate(11.207 6.322)" />
            <rect id="Rectangle_7023" data-name="Rectangle 7023" className="cls-3" width="2.017" height="3.476" transform="translate(15.112 6.322)" />
            <rect id="Rectangle_7024" data-name="Rectangle 7024" className="cls-3" width="2.017" height="3.476" transform="translate(18.776 6.322)" />
          </g>
          <g id="Group_17302" data-name="Group 17302">
            <rect
              id="Rectangle_7025"
              data-name="Rectangle 7025"
              className="cls-3"
              width="2.017"
              height="3.476"
              transform="translate(11.207 22.202)"
            />
            <rect
              id="Rectangle_7026"
              data-name="Rectangle 7026"
              className="cls-3"
              width="2.017"
              height="3.476"
              transform="translate(15.112 22.202)"
            />
            <rect
              id="Rectangle_7027"
              data-name="Rectangle 7027"
              className="cls-3"
              width="2.017"
              height="3.476"
              transform="translate(18.776 22.202)"
            />
          </g>
          <g id="Group_17303" data-name="Group 17303">
            <rect
              id="Rectangle_7028"
              data-name="Rectangle 7028"
              className="cls-3"
              width="2.017"
              height="3.476"
              transform="translate(8.577 11.342) rotate(90)"
            />
            <rect
              id="Rectangle_7029"
              data-name="Rectangle 7029"
              className="cls-3"
              width="2.017"
              height="3.476"
              transform="translate(8.577 15.247) rotate(90)"
            />
            <rect
              id="Rectangle_7030"
              data-name="Rectangle 7030"
              className="cls-3"
              width="2.017"
              height="3.476"
              transform="translate(8.577 18.911) rotate(90)"
            />
          </g>
          <g id="Group_17304" data-name="Group 17304">
            <rect
              id="Rectangle_7031"
              data-name="Rectangle 7031"
              className="cls-3"
              width="2.017"
              height="3.476"
              transform="translate(26.899 11.342) rotate(90)"
            />
            <rect
              id="Rectangle_7032"
              data-name="Rectangle 7032"
              className="cls-3"
              width="2.017"
              height="3.476"
              transform="translate(26.899 15.247) rotate(90)"
            />
            <rect
              id="Rectangle_7033"
              data-name="Rectangle 7033"
              className="cls-3"
              width="2.017"
              height="3.476"
              transform="translate(26.899 18.911) rotate(90)"
            />
          </g>
        </g>
        <path
          id="Path_15835"
          data-name="Path 15835"
          className="cls-3 cls-5"
          d="M4.719,9H6.3L4.083,2.876H2.355L.14,9H1.7l.366-1.082H4.353Zm-.75-2.233H2.46l.75-2.242ZM6.97,9H8.462V2.876H6.97Z"
          transform="translate(11.202 10.075)"
        />
      </g>
    </g>
  </svg>
);

export default SmartInsightsIcon;
